<template>
    <v-container>
        <v-row
            column
            justify-center
            align-center
            no-gutters
            id="customerDetailsChips"
        >
            <v-col cols="12" md="8" offset-md="2">
                <TranslatableBlockComponent :tstring="{string: 'formCustomerDetailsNote'}" />
            </v-col>
            <v-col
                cols="12"
                md="8"
                offset-md="2"
                class="py-0"
                v-show="!isCustomerConnected"
            >
                <v-alert color="primary" elevation="2" type="warning" dense>
                    <div class="d-flex align-center">
                        <TranslatableStringComponent :tstring="{string: 'existingCustomer'}" />
                        <TranslatableStringComponent :tstring="{string: 'connectToYourCustomerAccount'}" />
                        <v-btn
                            color="white"
                            class="ml-2"
                            small
                            light
                            @click="showModal = true"
                            >
                                <TranslatableStringComponent :tstring="{string: 'connect'}" />
                            </v-btn
                        >
                    </div>
                </v-alert>
            </v-col>
        </v-row>
        <v-row>
            <v-col cols="12" md="8" offset-md="2">
                <v-checkbox
                    v-model="selected"
                    :label="localize('useBillingShippingDetailsAsCustomerDetails')"
                    value="ContactCard"
                    hide-details
                    dense
                ></v-checkbox>

                <v-checkbox
                    v-model="selected"
                    :label="localize('fillNewDetailsForCustomer')"
                    value="ContactForm"
                    hide-details
                    dense
                ></v-checkbox>
            </v-col>
        </v-row>
        <v-expand-transition>
            <v-row
                v-if="selected === 'ContactCard'"
                column
                justify-center
                align-center
            >
                <v-col cols="12" md="8" offset-md="2">
                    <v-container>
                        <v-row column justify-center align-center>
                            <v-col
                                v-for="(item, index) in billingFormArray"
                                :key="index"
                                cols="12"
                                sm="6"
                            >
                                <v-card>
                                    <v-card-title>
                                        <ContactCardTitle :contact="item" />
                                    </v-card-title>
                                    <v-card-text
                                        style="
                                            font-size: 16px;
                                            line-height: 1.3;
                                        "
                                        class="py-0"
                                    >
                                        <ContactCardDetails :contact="item" />
                                    </v-card-text>
                                    <v-card-actions class="py-0 px-4">
                                        <v-chip-group
                                            v-model="primaryContactId"
                                            active-class="deep-purple accent-4 white--text"
                                            column
                                        >
                                            <v-chip :value="item.id"
                                                >
                                                <TranslatableStringComponent :tstring="{string: 'select'}" />
                                            </v-chip
                                            >
                                        </v-chip-group>
                                    </v-card-actions>
                                </v-card>
                            </v-col>
                            <v-col cols="12" class="text-right">
                                <v-btn
                                    color="primary"
                                    dense
                                    right
                                    @click="handleProceedToPayment()"
                                    >
                                        <TranslatableStringComponent :tstring="{string: 'proceedToPayment'}" />
                                    &rarr;</v-btn
                                >
                            </v-col>
                        </v-row>
                    </v-container>
                </v-col>
            </v-row>
        </v-expand-transition>
        <v-expand-transition>
            <v-row
                v-if="selected === 'ContactForm'"
                column
                justify-center
                align-center
            >
                <v-col cols="12" md="8" offset-md="2">
                    <v-card>
                        <FormContactCard
                            defaultemailid=""
                            :iseditable="false"
                            :resetContactForm="resetForm"
                        />
                    </v-card>
                </v-col>
            </v-row>
        </v-expand-transition>
        <ConnectCustomerDialog
            :showModal="showModal"
            parent="FormCustomer"
            stepperValue="2"
            @handlePostCustomerConnect="handlePostCustomerConnect()"
            @handleDialog="showModal = false"
        />
    </v-container>
</template>
<script>
import { mapState, mapGetters } from 'vuex'
import FormContactCard from '~/components/forms/FormContactCard.vue'
import ContactCardDetails from '~/components/ContactCardDetails'
import ContactCardTitle from '~/components/ContactCardTitle'
import handleSnackbar from '~/mixins/handleSnackbar'
import ConnectCustomerDialog from '~/components/ConnectCustomerDialog.vue'
import TranslatableStringComponent from '~/components/TranslatableStringComponent.vue'
import TranslatableBlockComponent from '~/components/TranslatableBlockComponent.vue'
export default {
    name: 'FormCustomerDetails',
    components: {
        FormContactCard,
        ContactCardDetails,
        ContactCardTitle,
        ConnectCustomerDialog,
        TranslatableStringComponent,
        TranslatableBlockComponent,
    },
    mixins: [handleSnackbar],
    data() {
        return {
            skeleleton: true,
            alert: false,
            skeloader: true,
            selected: '',
            resetForm: 'no',
            showModal: false,
        }
    },
    computed: {
        ...mapState('checkout', ['billingFormArray']),
        ...mapState('auth', ['webUser']),
        ...mapGetters({
            isCustomerConnected: 'auth/isCustomerConnected',
        }),

        primaryContactId: {
            get() {
                return this.$store.state.customerDetails.primaryContactId
            },
            set(value) {
                this.$store.commit(
                    'customerDetails/setPrimaryContactIdForCustomer',
                    value
                )
            },
        },
    },
    watch: {
        webUser(newVal, oldVal) {
            if (newVal) {
                this.getContacts()
            }
        },
        billingFormArray(newVal) {
            if (newVal.length > 0) {
                this.skeloader = false
            }
        },
        selected(newVal) {
            if (newVal === 'ContactForm') this.primaryContactId = undefined
            else this.resetForm = 'yes'
        },
    },
    mounted() {
        if (this.billingFormArray.length > 0) {
            this.skeloader = false
        }
    },
    methods: {
        async getContacts() {
            await this.$store.dispatch('checkout/getContacts')
            this.skeloader = false
        },
        handleProceedToPayment() {
            if (this.primaryContactId) {
                this.routerPush({ type: 'page', slugName: 'payment' })
            } else {
                this.hitSnackbar({string: 'pleaseSelectAContactToProceed'}, '')
            }
        },
    },
}
</script>
